import { AppState as State } from '@ducks/index';
import { OptionItem } from '@uiParts/selectBox';
import { Approver, ApproverListInfo, SelectApproverListInfo, SelectUser } from './types';

export const getRefreshId = (state: State) => state.property.refresh;
export const getRefreshId2 = (state: State) => state.property.refresh2;

export const checkIsLoading = (state: State) => state.property.isLoading;
export const checkIsLoading2 = (state: State) => state.property.isLoading2;
export const checkIsLoading3 = (state: State) => state.property.isLoading3;
export const checkIsSubmitting = (state: State) => state.property.isSubmitting;
export const checkIsNavigating = (state: State) => state.property.isNavigating;
export const checkIsNavigatingTo = (state: State) => state.property.isNavigatingTo;
export const checkIsNeedConfirm = (state: State) => state.property.isNeedConfirm;

export const getProperties = (state: State) => state.property.properties;
export const getPropertiesListInfo = (state: State) => state.property.propertiesListInfo;
export const getProperty = (state: State) => state.property.property;
export const getFloors = (state: State) => state.property.floors;
export const getRooms = (state: State) => state.property.rooms;
export const getMembers = (state: State) => state.property.members;
export const getMembersListInfo = (state: State) => state.property.membersListInfo;
export const getSelectMembers = (state: State) => state.property.selectMembers;
export const getSelectMembersListInfo = (state: State) => state.property.selectMembersListInfo;

/**
 * @summary 査収・承認者設定に関連する取得APIのLoading状態を返却する
 * @param {state} state
 * @returns {boolean}
 */
export const checkIsLoadingApprover: (state: State) => boolean = (state: State) =>
  state.property.isLoadingApprover;

/**
 * @summary 全建物管理者への査収・承認許可設定を返却する
 * @param {state} state
 * @returns {boolean}
 */
export const getCanApproveAllManager: (state: State) => boolean = (state: State) =>
  state.property.canApproveAllManager;

/**
 * @summary 建物詳細 査収・承認タブで使用する査収・承認者の一覧を返却する
 * @param {state} state
 * @returns {Approver[]}
 */
export const getApprovers: (state: State) => Approver[] = (state: State) =>
  state.property.approvers;

/**
 * @summary 建物詳細 査収・承認タブで使用する査収・承認者の一覧のページャ情報を返却する
 * @param {state} state
 * @returns {ApproverListInfo | null}
 */
export const getApproverListInfo: (state: State) => ApproverListInfo | null = (state: State) =>
  state.property.approversListInfo;

/**
 * @summary 査収・承認者以外の建物担当者一覧を返却する
 * @param {state} state
 * @returns {SelectUser[]}
 */
export const getSelectApprovers: (state: State) => SelectUser[] = (state: State) =>
  state.property.selectApprovers;

/**
 * @summary 査収・承認者以外の建物担当者一覧のページャ情報を返却する
 * @param {state} state
 * @returns {SelectApproverListInfo | null}
 */
export const getSelectApproverListInfo: (state: State) => SelectApproverListInfo | null = (
  state: State,
) => state.property.selectApproverListInfo;

/**
 * @summary 建物に設定されている全ての査収・承認者を返却する
 * @param {state} state
 * @returns {Approver[]}
 */
export const getAllApprovers: (state: State) => Approver[] = (state: State) =>
  state.property.allApprovers;

export const getTenants = (state: State) => state.property.tenants;
export const getTenantsListInfo = (state: State) => state.property.tenantsListInfo;

/**
 * @summary 建物に紐づくテナントデータ（全件）をコンボボックスで使用できる選択肢として返却する
 * @description 契約の登録/編集時に使用する
 * @param {State} state
 * @returns {OptionItem[]} テナント選択肢
 */
export const getTenantItemOptions = (state: State): OptionItem[] =>
  state.property.tenantItemList.map((tenant) => {
    return {
      title: tenant.contact_name,
      value: tenant.contact_id,
    };
  });

export const getAddressAutofill = (state: State) => state.property.addressAutofill;
export const getPropertyInformation = (state: State) => state.property.information;

export const getContracts = (state: State) => state.property.contracts;
export const getContractsListInfo = (state: State) => state.property.contractsListInfo;
export const getContract = (state: State) => state.property.contract;
export const getPropertyUserList = (state: State) => state.property.propertyUserList;
export const getDocumentFileSize = (state: State) => state.property.documentFileSize;
